import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import Modal from 'scy/Modal';
import { LightBackground } from 'scy/Background';
import { accent } from 'scy/text/styles.mod.scss';
import { PrimaryButton } from 'scy/buttons';
import Logo from 'images/icons/logos/combo-drop-pin.svg?react-svg';
import { width100 } from 'scy/utils.mod.scss';
import padding from 'scy/padding.mod.scss';
import styles from './EditModal.mod.scss';
import { title } from './styles.mod.scss';

export default function GiftOrderEditModal({
  order,
  isOpen,
  handleClose,
  updateNotes,
  updateUnit
}) {
  const addressDetails = order.delivery_address_detail || {};
  const unit = addressDetails.unit || '';
  const deliveryNotes = order.delivery_notes || '';

  const [formUnit, setFormUnit] = useState(unit);
  const [formNotes, setFormNotes] = useState(deliveryNotes);

  useEffect(() => {
    if (isOpen) {
      setFormUnit(unit);
      setFormNotes(deliveryNotes);
    }
  }, [deliveryNotes, isOpen, unit]);

  return (
    <Modal
      isOpen={isOpen}
      handleClose={handleClose}
      className={styles.container}
    >
      <LightBackground className={styles.background}>
        <div className={classnames(padding.sm, accent)}>
          <Logo />
        </div>
        <h4 className={title}>Edit delivery details</h4>
        <p className={styles.subtitle}>
          To change street address or city please contact Saucey support team.
        </p>

        <form
          onSubmit={e => {
            e.preventDefault();
            updateUnit(formUnit);
            updateNotes(formNotes);
            handleClose();
          }}
        >
          <div className={styles.row}>
            <input
              placeholder="Street Address"
              name="streetAddress"
              id="streetAddress"
              className={styles.input}
              defaultValue={addressDetails.address}
              disabled
            />
          </div>

          <div className={styles.row}>
            <input
              placeholder="Add unit number?"
              name="unit"
              id="unit"
              autoFocus
              className={styles.input}
              value={formUnit}
              onChange={e => setFormUnit(e.target.value)}
            />
          </div>

          <div className={styles.row}>
            <input
              placeholder="City"
              name="city"
              id="city"
              className={styles.input}
              defaultValue={addressDetails.city}
              disabled
            />
          </div>

          <div className={styles.row}>
            <input
              placeholder="State"
              name="state"
              id="state"
              className={styles.input}
              defaultValue={addressDetails.state}
              disabled
            />
            <input
              placeholder="Zip Code"
              name="zip"
              id="zip"
              className={styles.input}
              defaultValue={addressDetails.zip}
              disabled
            />
          </div>

          <div className={styles.row}>
            <textarea
              placeholder="Add delivery notes?"
              name="deliveryNotes"
              id="deliveryNotes"
              className={styles.textarea}
              value={formNotes}
              onChange={e => setFormNotes(e.target.value)}
              maxLength="150"
            />
          </div>

          <div className={padding.sm}>
            <PrimaryButton className={width100}>Save Edits</PrimaryButton>
          </div>
        </form>
      </LightBackground>
    </Modal>
  );
}
